<h3 class="!tw-mb-0 tw-pt-8 tw-pl-2 tw-border-b-2 !tw-font-bold">{{title}}</h3>
<div class="tw-grid tw-grid-cols-2 tw-gap-2 tw-gap-x-2 tw-py-2">
  <div class="tw-grid tw-grid-flow-col tw-justify-between tw-px-4"
    *ngFor="let data of dataListHead; last as last"
  >
    <span class="text-muted">{{ data.label }}</span>
    <span [ngSwitch]="data.metadata?.pipe">
      <span *ngSwitchCase="'date'">{{ data.value | date }}</span>
      <span *ngSwitchCase="'phone'">+{{ data.metadata.phoneCountryCode }} {{ data.value | phone: data.metadata.countryCode }}</span>
      <span *ngSwitchCase="'percent'">{{ data.value | percentage }}</span>
      <span *ngSwitchCase="'ssn'">{{ data.value | ssn }}</span>
      <span *ngSwitchCase="'currency'">{{ data.value }}</span>
      <span *ngSwitchCase="'number'">{{ data.value | number: '1.2-2' }}</span>
      <span *ngSwitchDefault>{{ data.value !== "" ? data.value : "-" }}</span>
    </span>
    <span *ngIf="data.metadata?.link"><br><a href="{{data.metadata.link}}" target="_blank">Street View</a></span>
    <mat-icon *ngIf="data.metadata?.icon" [style.color]="data.metadata?.icon.color" matTooltip="{{ data.metadata?.icon.tooltip }}">{{ data.metadata?.icon.id }}</mat-icon>
  </div>
</div>
<mat-divider></mat-divider>